import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "expandable-list" }
const _hoisted_2 = {
  key: 0,
  class: "expandable-list__caption"
}
const _hoisted_3 = { class: "expandable-list__items" }
const _hoisted_4 = {
  key: 0,
  class: "expandable-list__toggle"
}
const _hoisted_5 = {
  key: 1,
  class: "expandable-list__toggle"
}

import { ref, onMounted } from 'vue';
  import useWebsiteTexts from '@/composables/useWebsiteTexts';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandableList',
  props: {
    items: {
      type: Array,
      required: true,
    },
    initialVisibleCount: {
      type: Number,
      default: 3,
    },
    caption: {
      type: String,
    },
    getItemName: {
      type: Function,
    },
  },
  setup(__props) {

const props = __props

  

  const displayedItems: any = ref([]);
  const visibleItemCount = ref(props.initialVisibleCount);
  const showExpandLink = ref(true);

  const updateDisplayedItems = () => {
    displayedItems.value = props.items.slice(0, visibleItemCount.value);
  };

  const expandList = () => {
    visibleItemCount.value = props.items.length;
    updateDisplayedItems();
    showExpandLink.value = false;
  };

  const collapseList = () => {
    visibleItemCount.value = props.initialVisibleCount;
    updateDisplayedItems();
    showExpandLink.value = true;
  };

  const { websiteText } = useWebsiteTexts();

  onMounted(() => {
    updateDisplayedItems();
  });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.caption)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.caption), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_TransitionGroup, { name: "fade" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedItems.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              class: "expandable-list__item",
              to: item.url,
              key: index
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.getItemName?.(item)), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ]),
        _: 1
      }),
      (showExpandLink.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("a", { onClick: expandList }, _toDisplayString(_unref(websiteText)('common_expand').value || 'Expand'), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("a", { onClick: collapseList }, _toDisplayString(_unref(websiteText)('common_collapse').value || 'Collapse'), 1)
          ]))
    ])
  ]))
}
}

})